import Backbone from 'backbone';

export const UnenrollPatientModel = Backbone.Model.extend({

  defaults: {
    patient_id: '',
    unenroll_reason_options: ''
  },

  initialize: function( options ) {
    this.channel = Backbone.Radio.channel( 'AppChannel' );
    this.app = this.channel.request( 'app' );
  }
});